import React from "react";
import Box from "@mui/material/Box";
import AppLogo from "../components/app/AppLogo";

const Home = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        textAlign: "center",
      }}
    >
      <AppLogo height={150} sx={{ zIndex: -1 }} />
    </Box>
  );
};

export default Home;
